import Utils from './index';
import { Api } from '../typings/api';
import { MenuItemType } from '../typings/menu';

export interface RequiredItemData {
	id: number;
	isIcon: boolean;
	url?: string;
}

export const getRequiredItemsDatas = (template: Api.Template): RequiredItemData[] => {
	let requiredItems: RequiredItemData[] = [];

	if (template && template.welcomepage && template.welcomepage.url) {
		const welcomePageId = Utils.getMediaId(template.welcomepage.url);
		requiredItems.push({
			id: welcomePageId,
			url: template.welcomepage.url,
			isIcon: false,
		});
	}

	if (template && template.menu) {
		const menuFormat = Utils.getScreenFormat();
		const menu = template.menu[menuFormat] || template.menu.default;

		const getItemId = (requiredData: string, isIcon: boolean) => {
			const mediaId = Utils.getMediaId(requiredData);
			if (mediaId > 0) {
				requiredItems.push({ id: mediaId, isIcon });
			}
		};

		Object.keys(menu).forEach(menuPosition => {
			menu[menuPosition].forEach(menuItem => {
				if (menuItem.type === MenuItemType.Page) {
					getItemId(menuItem.target, false);
				}

				if (menuItem.icon) {
					getItemId(menuItem.icon, true);
				}
			});
		});
	}

	return requiredItems.filter((page, index, self) => {
		return index === self.findIndex(item => item.id === page.id);
	});
};

export const getRequiredItemIds = (template: Api.Template): Set<number> => {
	return new Set(getRequiredItemsDatas(template).map(item => item.id));
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/requiredItems.ts